<template>
  <div class="orderMessageViewContainer">
    <div class="Toolbar">
      <div
        class="cursorPointer backBtn"
        @click="onClickGoBack"
      >
        <font-awesome-icon
          style="margin-left: 10px;"
          :icon="['fal', 'angle-left']"
          size="2x"
        />
        <span class="u-ml10 TextWithIcon">
          注文詳細情報
        </span>
      </div>
    </div>
    <!-- 注文ステータス -->
    <div
      v-if="order.status"
      class="message-status"
    >
      注文ステータス：
      <span class="statusBold">
        {{ order.status.name }}
      </span>
    </div>

    <!-- ステータス -->
    <!-- Step1: 新規注文 = PROCESSING -->
    <!-- Step2: レイアウト作成中 = PROCESSING_CREATING_LAYOUT -->
    <!-- Step3: レイアウト調整中 = REVISING_LAYOUT -->
    <!-- Step4: 注文確定 = CONFIRMED -->
    <!-- Step5: 発送済み = SHIPPED -->
    <div class="AdminOrderMessageHeaderTop">
      <el-row>
        <el-col :span="24">
          <div
            v-if="buttonGroup"
            id="btn-group"
            class="AdminOrderDetailHeaderTopCenter flex center"
          >
            <!-- ステータス: スペーサー -->
            <div class="box grow" />

            <!-- ステータス: レイアウト作成 -->
            <el-button
              v-if="isNeededLayoutReply"
              class="statusButton"
              :type="fetchTypeByStep(0)"
              :plain="computedStepByOrderStatus > 0"
              :disabled="fetchIsDisabledBySteps([1, 3, 4])"
              @click="_onClickLayoutCreating()"
            >
              {{ computedStepByOrderStatus > 0 ? "レイアウト作成開始済み" : "レイアウト作成を開始する" }}
            </el-button>

            <!-- ステータス: アロー -->
            <i
              v-if="isArrow1Visible"
              id="arrow-icon1"
              class="el-icon-caret-right SelectTabletType-CaretRightIcon arrow-gray"
            />

            <!-- ステータス: レイアウト調整 -->
            <el-button
              v-if="isNeededLayoutReply"
              class="statusButton"
              :type="fetchTypeByStep(1)"
              :plain="computedStepByOrderStatus > 1"
              :disabled="fetchIsDisabledBySteps([0, 2, 4])"
              @click="_onClickLayoutAdjust()"
            >
              {{ computedStepByOrderStatus > 1 ? "レイアウト調整開始済み" : "レイアウト調整を開始する" }}
            </el-button>

            <!-- ステータス: アロー -->
            <i
              v-if="isArrow1Visible"
              id="arrow-icon1"
              class="el-icon-caret-right SelectTabletType-CaretRightIcon arrow-gray"
            />

            <!-- ステータス: 注文確定 -->
            <el-button
              v-if="isNeededLayoutReply"
              class="statusButton"
              :type="fetchTypeByStep(2)"
              :plain="computedStepByOrderStatus > 2"
              :disabled="fetchIsDisabledBySteps([0, 1, 3])"
              @click="_onClickConfirmOrder()"
            >
              {{ computedStepByOrderStatus > 2 ? "注文を確定済み" : "注文を確定する" }}
            </el-button>

            <!-- ステータス: アロー -->
            <i
              v-if="isArrow2Visible"
              id="arrow-icon2"
              class="el-icon-caret-right SelectTabletType-CaretRightIcon arrow-gray"
            />

            <!-- ステータス: 発送済み -->
            <el-button
              class="statusButton"
              :type="fetchTypeByStep(3)"
              :plain="computedStepByOrderStatus > 3"
              :disabled="fetchIsDisabledBySteps([0, 1, 2, 4])"
              @click="_onClickShippedOrder()"
            >
              {{ computedStepByOrderStatus > 3 ? "発送済み" : "発送済みにする" }}
            </el-button>

            <!-- ステータス: スペーサー -->
            <div class="box grow" />
          </div>
        </el-col>
      </el-row>
    </div>
    <div
      class="adminOrderMessage"
      id="messageContainer"
      v-if="isValidOrderAvailable"
    >
      <div class="column">
        <div class="adminOrderContentTables" id="adminContent">
          <!-- basic informations table -->
          <table class="adminOrderContentTable">
            <tr>
              <th class="adminOrderContentTable-th" colspan="2">基本情報</th>
            </tr>
            <tr v-for="item in basicInformations" :key="item[0]">
              <td class="adminOrderContentTable-td">{{ item[0] }}</td>
              <td class="adminOrderContentTable-td">{{ item[1] }}</td>
            </tr>
          </table>

          <!-- customer informations table -->
          <table class="adminOrderContentTable">
            <tr>
              <th class="adminOrderContentTable-th" colspan="2">
                お客様情報
              </th>
            </tr>
            <tr v-for="item in customerInformations" :key="item[0]">
              <td class="adminOrderContentTable-td">{{ item[0] }}</td>
              <td class="adminOrderContentTable-td">{{ item[1] }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="column--right">
        <AdminOrderChat :order="primaryOrder" />
      </div>
    </div>

    <!-- Dialogs Division -->
    <div class="AdminOrderMessageDialog">
      <!-- レイアウト作成: create layout order dialog -->
      <el-dialog
        :visible.sync="layoutCreatingDialogVisible"
        :close-on-click-modal="!isSendingRequest"
        width="35%"
        center
      >
        <span class="dialog-text">
          {{ computedStepByOrderStatus > 1 ? "レイアウト作成開始に戻しますか？" : "レイアウト作成を開始しますか？" }}
        </span>

        <!-- レイアウト作成: アクション -->
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            class="cancel-btn"
            :disabled="isSendingRequest"
            @click="cancelLayoutCreating()"
          >
            キャンセル
          </el-button>
          <el-button
            class="blue-text-btn"
            :loading="isSendingRequest"
            @click="startLayoutCreating()"
          >
            {{ computedStepByOrderStatus > 1 ? "戻す" : "開始する" }}
          </el-button>
        </span>
      </el-dialog>

      <!-- レイアウト調整: adjust layout order dialog -->
      <el-dialog
        :visible.sync="layoutAdjustDialogVisible"
        :close-on-click-modal="!isSendingRequest"
        width="35%"
        center
      >
        <span class="dialog-text">
          {{ computedStepByOrderStatus > 2 ? "レイアウト調整開始に戻しますか？" : "レイアウト調整を開始しますか？" }}
        </span>
        <AdminOrdersImageUploader
          ref="adminOrdersImageUploader"
          v-if="computedStepByOrderStatus < 2"
          class="mt-4"
          :images="images"
          @updateImageFile="updateImageFile"
          @initImageFile="images = []"
        />

        <!-- レイアウト調整: アクション -->
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            class="cancel-btn"
            :disabled="isSendingRequest"
            @click="cancelLayoutAdjust()"
          >
            キャンセル
          </el-button>
          <el-button
            class="blue-text-btn"
            :loading="isSendingRequest"
            @click="startLayoutAdjust()"
          >
            {{ computedStepByOrderStatus > 2 ? "戻す" : "開始する" }}
          </el-button>
        </span>
      </el-dialog>

      <!-- 出荷日を選択: delivery date input dialog -->
      <el-dialog
        class="dateInputDialog"
        :visible.sync="dateInputDialogVisible"
        :close-on-click-modal="!isSendingRequest"
        width="35%"
        center
      >
        <span class="dialog-text">
          出荷日を選択してください。
        </span>
        <div class="FormGroup">
          <el-date-picker
            v-model="fixedShippingDate"
            id="date-input"
            class="date-input"
            type="date"
            placeholder="出荷日を選択してください"
            :editable="false"
          />
        </div>

        <!-- 出荷日を選択: アクション -->
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            class="cancel-btn"
            :disabled="isSendingRequest"
            @click="cancelDateInput()"
          >
            キャンセル
          </el-button>
          <el-button
            class="blue-text-btn"
            :loading="isSendingRequest"
            @click="_onClickShippingDateOK()"
          >
            OK
          </el-button>
        </span>
      </el-dialog>

      <!-- 注文を確定: confirm order dialog -->
      <el-dialog
        :visible.sync="confirmOrderDialogVisible"
        :close-on-click-modal="!isSendingRequest"
        width="35%"
        center
      >
        <span class="dialog-text">
          {{ computedStepByOrderStatus > 3 ? "注文確定に戻しますか？" : "注文を確定しますか？" }}
        </span>

        <!-- 注文を確定: アクション -->
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            class="cancel-btn"
            :disabled="isSendingRequest"
            @click="cancelConfirmOrder()"
          >
            キャンセル
          </el-button>
          <el-button
            class="blue-text-btn"
            :loading="isSendingRequest"
            @click="_onClickConfirm()"
          >
            {{ computedStepByOrderStatus > 3 ? "戻す" : "確定" }}
          </el-button>
        </span>
      </el-dialog>

      <!-- 発送済み: shipped order dialog -->
      <el-dialog
        :visible.sync="shippedDialogVisible"
        :close-on-click-modal="!isSendingRequest"
        width="35%"
        center
      >
        <span class="dialog-text">
          この注文を発送済みにしますか？
        </span>

        <!-- アクション -->
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            class="cancel-btn"
            :disabled="isSendingRequest"
            @click="shippedDialogVisible = false"
          >
            キャンセル
          </el-button>
          <el-button
            class="blue-text-btn"
            :loading="isSendingRequest"
            @click="_onClickShipped()"
          >
            はい
          </el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import OrderUsecase from "@/usecases/order.usecase";
import AdminOrderChat from "@/views/admin/AdminOrderChat.vue";
import AdminOrdersImageUploader from "@/components/Admin/Orders/ImageUploader";
import Order from "@/entities/order.entity";
import moment from "moment";

// 注文ステータス [納期確認, レイアウト作成, レイアウト調整, 注文確定, 発送済み]
const ORDER_STATUS = [
  "PROCESSING",
  "PROCESSING_CREATING_LAYOUT",
  "REVISING_LAYOUT",
  "CONFIRMED",
  "SHIPPED",
];

export default {
  components: {
    AdminOrderChat,
    AdminOrdersImageUploader,
  },
  data () {
    return {
      order: {},
      basicInformations: [],
      customerInformations: [],
      orderUsecase: new OrderUsecase(),
      isDisableLayoutCreating: false,
      isDisableLayoutAdjust: false,
      isDisableOrder: false,
      isDisableShipped: false,
      layoutCreatingDialogVisible: false,
      layoutAdjustDialogVisible: false,
      dateInputDialogVisible: false,
      confirmOrderDialogVisible: false,
      shippedDialogVisible: false,
      fixedShippingDate: "",
      orderStatus: "",
      isLayoutVisible: false,
      isOrderVisible: false,
      isShippedVisible: false,
      isArrow1Visible: false,
      isArrow2Visible: false,
      isNeededLayoutReply: "",
      // 「レイアウト調整を開始する」のフィルアップロード用
      images: [],
      isSendingRequest: false,
      primaryOrderData: null,
    };
  },
  async created () {
    this.syncOrder();
  },
  computed: {
    computedStepByOrderStatus () {
      const { orderStatus } = this;
      const step = ORDER_STATUS.indexOf(orderStatus);

      return step;
    },
    isValidOrderAvailable () {
      return this.order instanceof Order;
    },
    primaryOrder () {
      const src = this.primaryOrderData;
      if (src && src.id) {
        return src;
      }
      return this.order;
    },
    buttonGroup () {
      return this.order.buttonGroup;
    },
    /* to get 注文を確定する button class action */
    getConfirmClass () {
      if (!this.isNeededLayoutReply) {
        if (this.orderStatus === "PROCESSING") {
          return "";
        } else if (this.orderStatus === "CONFIRMED") {
          return "bggray-colorblack";
        } else if (this.orderStatus === "SHIPPED") {
          return "bggray-colorblack";
        } else {
          return "";
        }
      } else {
        if (this.orderStatus === "PROCESSING") {
          return "bggray-colorwhite";
        } else if (this.orderStatus === "REVISING_LAYOUT") {
          return "";
        } else if (this.orderStatus === "CONFIRMED") {
          return "bggray-colorblack";
        } else if (this.orderStatus === "SHIPPED") {
          return "bggray-colorblack";
        } else {
          return "";
        }
      }
    },
    /* to get 発送済みにする button class action */
    getShippedClass () {
      if (!this.isNeededLayoutReply) {
        if (this.orderStatus === "PROCESSING") {
          return "bggray-colorwhite";
        } else if (this.orderStatus === "CONFIRMED") {
          return "";
        } else if (this.orderStatus === "SHIPPED") {
          return "bggray-colorblack";
        } else {
          return "";
        }
      } else {
        if (
          this.orderStatus === "PROCESSING" ||
          this.orderStatus === "REVISING_LAYOUT"
        ) {
          return "bggray-colorwhite";
        } else if (this.orderStatus === "SHIPPED") {
          return "bggray-colorblack";
        } else if (this.orderStatus === "CONFIRMED") {
          return "";
        } else {
          return "";
        }
      }
    },
  },
  methods: {
    /**
     * fetch type attribute value for el-button
     * @param   {number}  applicableStep  [applicableStep description]
     * @return  {string}                  [return description]
     */
    fetchTypeByStep (applicableStep) {
      const { computedStepByOrderStatus } = this;

      if (applicableStep === computedStepByOrderStatus) {
        return "primary";
      }

      return "info";
    },

    /**
     * fetch disabled attribute value for el-button
     * @param   {array}  steps  [steps description]
     * @return  {boolean}       isDisabled
     */
    fetchIsDisabledBySteps (steps) {
      const { computedStepByOrderStatus } = this;
      const isDisabled = steps.some(step => step === computedStepByOrderStatus);

      return isDisabled;
    },
    async syncOrder () {
      const orderId = this.$route.params.id;
      this.orderDetailId = orderId;
      this.order = await this.orderUsecase.getOrder({ orderId });
      this.primaryOrderData = await this.loadPrimaryOrder(this.order);
      if (this.order) {
        this.fixedShippingDate = this.order.detail.fixedShippingDate;
        this.customerItems = this.order;
        this.orderStatus = this.order.status.code;
        this.isNeededLayoutReply = this.order.detail.isNeededLayoutReply;
        this.getButtonsAction();
        this.getBasicInformations(this.order);
        this.getCustomerInformations(this.order);
      }
      this.setBtnVisible();
    },
    async loadPrimaryOrder (currentOrder) {
      if (!currentOrder || !currentOrder.id) {
        return null;
      }
      const parentOrderId =
        currentOrder.parentOrder && currentOrder.parentOrder.id
          ? currentOrder.parentOrder.id
          : currentOrder.id;
      const primaryOrder =
        parentOrderId === currentOrder.id
          ? currentOrder
          : await this.orderUsecase.getOrder({ orderId: parentOrderId });
      if (!primaryOrder) {
        return null;
      }
      return primaryOrder instanceof Order ? primaryOrder : Order.fromJson(primaryOrder);
    },
    // set buttons are disable or enable condition
    setBtnVisible () {
      if (!this.isNeededLayoutReply) {
        if (
          this.orderStatus === "PROCESSING" ||
          this.orderStatus === "PROCESSING_CREATING_LAYOUT"
        ) {
          this.isDisableOrder = false;
          this.isDisableShipped = true;
        } else if (this.orderStatus === "CONFIRMED") {
          this.isDisableOrder = true;
          this.isDisableShipped = false;
        } else if (this.orderStatus === "SHIPPED") {
          this.isDisableOrder = true;
          this.isDisableShipped = true;
        }
      } else {
        if (this.orderStatus === "PROCESSING") {
          this.isDisableLayoutCreating = false;
          this.isDisableLayoutAdjust = true;
          this.isDisableOrder = true;
          this.isDisableShipped = true;
        } else if (this.orderStatus === "PROCESSING_CREATING_LAYOUT") {
          this.isDisableLayoutCreating = true;
          this.isDisableLayoutAdjust = false;
          this.isDisableOrder = true;
          this.isDisableShipped = true;
        } else if (this.orderStatus === "REVISING_LAYOUT") {
          this.isDisableLayoutCreating = false;
          this.isDisableLayoutAdjust = true;
          this.isDisableOrder = false;
          this.isDisableShipped = true;
        } else if (this.orderStatus === "CONFIRMED") {
          this.isDisableLayoutCreating = true;
          this.isDisableLayoutAdjust = false;
          this.isDisableOrder = true;
          this.isDisableShipped = false;
        } else if (this.orderStatus === "SHIPPED") {
          this.isDisableLayoutAdjust = true;
          this.isDisableOrder = false;
          this.isDisableShipped = true;
        }
      }
    },
    /* to get basic informations */
    getBasicInformations (order) {
      let orderDate = "";
      let orderedAtDate = order.orderedAt;
      let expectedShippingDate = order.detail.expectedShippingDate;
      let fixedShippingDate = order.detail.fixedShippingDate;
      if (orderedAtDate) {
        orderDate = moment
          .unix(String(orderedAtDate))
          .format("YYYY/MM/DD  HH:mm");
      }
      let layout = order.detail.isNeededLayoutReply === true ? "有" : "無";
      this.basicInformations = [
        ["注文番号", order.orderNumber],
        ["受注日", orderDate],
        ["ステータス", order.status.name],
        ["レイアウト調整の有無", layout],
        [
          "希望納期",
          expectedShippingDate ? expectedShippingDate.replace(/-/g, "/") : "",
        ],
        ["送り状番号", ""],
        [
          "出荷日",
          fixedShippingDate ? fixedShippingDate.replace(/-/g, "/") : "",
        ],
        [
          "得意先",
          order.client && order.client.clientGroup
            ? order.client.clientGroup.name
            : "[得意先無し]",
        ],
        [
          "得意先担当者",
          order.client ? order.client.name : "[削除されたユーザー]",
        ],
      ];
    },
    /* to get customer informations */
    getCustomerInformations (order) {
      let { customer } = order;
      this.customerInformations = [
        ["お名前", customer.name],
        ["郵便番号", customer.zipcode],
        ["住所", customer.address],
        ["電話番号", customer.tel],
        ["宗派", customer.sect],
        ["菩提寺", customer.familyTemple],
        ["備考", customer.note],
      ];
    },
    /* to get (レイアウト調整を開始する、注文を確定する, 発送済みにする)button action */
    async getButtonsAction () {
      await this.getButtonVisible();
    },
    /* to show/hide (レイアウト調整を開始する、注文を確定する,発送済みにする)action */
    getButtonVisible () {
      if (this.isNeededLayoutReply) {
        this.isLayoutVisible = true;
        this.isOrderVisible = true;
        this.isShippedVisible = true;
        this.isArrow1Visible = true;
        this.isArrow2Visible = true;
      } else {
        this.isLayoutVisible = false;
        this.isOrderVisible = true;
        this.isShippedVisible = true;
        this.isArrow1Visible = false;
        this.isArrow2Visible = true;
      }
    },
    /* to cancel start layout creating, close layout start dialog  */
    cancelLayoutCreating () {
      this.layoutCreatingDialogVisible = false;
    },
    /* to update order by status=REVISING_LAYOUT */
    async startLayoutCreating () {
      try {
        this.isSendingRequest = true;

        // update it
        await this.updateStatusLayoutCreating();

        // close modal
        this.layoutCreatingDialogVisible = false;

        // it succeed, so I notify it
        this.$notify({
          message: "レイアウト作成を開始しました。",
        });

        // to get order update list
        this.syncOrder();
      } catch (err) {
        alert(err.errors[0].message);
      } finally {
        this.isSendingRequest = false;
      }
    },
    /* to update order, save order update information */
    async updateStatusLayoutCreating () {
      const orderId = this.getPrimaryOrderId();
      if (!orderId) {
        return;
      }
      const OrderUpdateInputParam = {
        orderId: orderId,
        status: "PROCESSING_CREATING_LAYOUT",
      };
      if (OrderUpdateInputParam) {
        const res = await this.orderUsecase.orderUpdateStatus(OrderUpdateInputParam);
        return res;
      }
    },
    /* to cancel start layout, close layout start dialog  */
    cancelLayoutAdjust () {
      this.layoutAdjustDialogVisible = false;
    },
    /* to update order by status=REVISING_LAYOUT */
    async startLayoutAdjust () {
      let message = "";
      if (this.orderStatus === "PROCESSING_CREATING_LAYOUT") {
        try {
          // update it
          await this.updateOrderStartLayoutRevision();

          // clear input for image file
          this.$refs.adminOrdersImageUploader.initImageFiles();

          // close modal
          this.layoutAdjustDialogVisible = false;
          // it succeed, so I notify it
          message = "レイアウト調整を開始しました。";
          this.$notify({ message });
          // to get order update list
          this.syncOrder();
        } catch (err) {
          alert(err.errors[0].message);
        }
        return;
      }
      // レイアウト調整開始に戻す時
      try {
        this.isSendingRequest = true;

        // update it
        await this.updateStatusLayoutAdjust();

        // close modal
        this.layoutAdjustDialogVisible = false;

        // it succeed, so I notify it
        this.$notify({
          message: "レイアウト調整を開始しました。",
        });

        // to get order update list
        this.syncOrder();
      } catch (err) {
        alert(err.errors[0].message);
      } finally {
        this.isSendingRequest = false;
      }
    },
    /* to update order from PROCESSING to REVISING_LAYOUT */
    async updateOrderStartLayoutRevision () {
      const orderId = this.getPrimaryOrderId();
      if (!orderId) {
        return;
      }
      const OrderUpdateInputParam = {
        orderId: orderId,
        image: this.images.length ? this.images[0] : "", // "REVISING_LAYOUT",
      };
      if (OrderUpdateInputParam) {
        const res = await this.orderUsecase.orderStartLayoutRevision(OrderUpdateInputParam);
        return res;
      }
    },
    /* to update order, save order update information */
    async updateStatusLayoutAdjust () {
      const orderId = this.getPrimaryOrderId();
      if (!orderId) {
        return;
      }
      const OrderUpdateInputParam = {
        orderId: orderId,
        status: "REVISING_LAYOUT",
      };

      if (OrderUpdateInputParam) {
        const res = await this.orderUsecase.orderUpdateStatus(OrderUpdateInputParam);
        return res;
      }
    },
    /* to cancel delivery date input, close date input dialog  */
    cancelDateInput () {
      this.dateInputDialogVisible = false;
      this.fixedShippingDate = this.order.detail.fixedShippingDate;
    },
    /* to open confirm order dialog */
    _onClickShippingDateOK () {
      if (this.isDisableOrder) {
        return false;
      } else {
        this.confirmOrderDialogVisible = true;
        setTimeout(() => {
          this.dateInputDialogVisible = false;
        }, 100);
      }
    },
    /* to cancel confirm order, close confirm order dialog */
    cancelConfirmOrder () {
      this.confirmOrderDialogVisible = false;
      this.dateInputDialogVisible = false;
    },
    /* to update fixedShippingDate and status of order by CONFIRMED */
    async _onClickConfirm () {
      const { orderStatus } = this;

      try {
        this.isSendingRequest = true;

        // update it
        if (orderStatus === "SHIPPED") {
          // ステータスだけ変更
          await this.updateStatusConfirmedWithoutShippingDate();
        } else {
          await this.updateStatusConfirmed();
        }

        // close modal
        this.confirmOrderDialogVisible = false;

        // it succeed, so I notify it
        this.$notify({
          message: "注文を確定しました。",
        });

        // to get order update list
        this.syncOrder();
      } catch (err) {
        alert(err.errors[0].message);
      } finally {
        this.isSendingRequest = false;
      }
    },
    /* to update order, save order update information */
    async updateStatusConfirmed () {
      this.dateInputDialogVisible = false;
      const orderId = this.getPrimaryOrderId();
      if (!orderId) {
        return;
      }
      const orderParam = {
        status: "CONFIRMED",
        detail: {
          fixedShippingDate: this.getShippingDate(this.fixedShippingDate),
        },
      };
      const OrderUpdateInputParam = {
        orderId: orderId,
        order: orderParam,
      };
      if (OrderUpdateInputParam) {
        const res = await this.orderUsecase.orderUpdate(OrderUpdateInputParam);
        return res;
      }
    },

    /* to update order, save order update information without fixedShippingDate */
    async updateStatusConfirmedWithoutShippingDate () {
      const orderId = this.getPrimaryOrderId();
      if (!orderId) {
        return;
      }
      const OrderUpdateInputParam = {
        orderId,
        status: "CONFIRMED",
      };

      if (OrderUpdateInputParam) {
        const res = await this.orderUsecase.orderUpdateStatus(OrderUpdateInputParam);
        return res;
      }
    },

    /* to update order by SHIPPED order status */
    async _onClickShipped () {
      try {
        this.isSendingRequest = true;

        // update it
        await this.updateStatusShipped();

        // close modal
        this.shippedDialogVisible = false;

        // it succeed, so I notify it
        this.$notify({
          message: "注文を発送しました。",
        });

        // to get order update list
        this.syncOrder();
      } catch (err) {
        alert(err.errors[0].message);
      } finally {
        this.isSendingRequest = false;
      }
    },
    /* to update order, save order update information */
    async updateStatusShipped () {
      const orderId = this.getPrimaryOrderId();
      if (!orderId) {
        return;
      }
      const OrderUpdateInputParam = {
        orderId: orderId,
        status: "SHIPPED",
      };
      if (OrderUpdateInputParam) {
        const res = await this.orderUsecase.orderUpdateStatus(OrderUpdateInputParam);
        return res;
      }
    },
    getPrimaryOrderId () {
      return this.primaryOrder && this.primaryOrder.id
        ? this.primaryOrder.id
        : null;
    },
    /* to open layout creating order dialog */
    _onClickLayoutCreating () {
      const { orderStatus } = this;

      if (this.isDisableLayoutCreating) {
        return;
      }

      // ここの条件はなくても良いかもしれないが
      // isNeededLayoutReply などの不明な値があるため
      if (
        orderStatus === "PROCESSING" ||
        orderStatus === "REVISING_LAYOUT"
      ) {
        this.layoutCreatingDialogVisible = true;
      }
    },
    /* to open layout adjust order dialog */
    _onClickLayoutAdjust () {
      const { orderStatus } = this;

      if (this.isDisableLayout) {
        return;
      }

      // ここの条件はなくても良いかもしれないが
      // isNeededLayoutReply などの不明な値があるため念の為
      if (
        orderStatus === "PROCESSING_CREATING_LAYOUT" ||
        orderStatus === "CONFIRMED"
      ) {
        this.layoutAdjustDialogVisible = true;
      }
    },
    /* to open delivery date input dialog */
    _onClickConfirmOrder () {
      const { orderStatus } = this;

      if (this.isDisableOrder) {
        return;
      }

      // ここの条件はなくても良いかもしれないが
      // isNeededLayoutReply などの不明な値があるため念の為
      if (orderStatus === "REVISING_LAYOUT") {
        this.fixedShippingDate = "";
        this.dateInputDialogVisible = true;
      } else if (orderStatus === "SHIPPED") {
        this.confirmOrderDialogVisible = true;
      }
    },
    /* to open shipped order dialog */
    _onClickShippedOrder () {
      const { orderStatus } = this;

      if (this.isDisableShipped) {
        return;
      }

      // ここの条件はなくても良いかもしれないが
      // isNeededLayoutReply などの不明な値があるため念の為
      if (orderStatus === "CONFIRMED") {
        this.shippedDialogVisible = true;
      }
    },
    /* to get shipping date format */
    getShippingDate (shipDate) {
      var date = new Date(shipDate);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var dt = date.getDate();
      if (dt < 10) {
        dt = "0" + dt;
      }
      if (month < 10) {
        month = "0" + month;
      }
      return shipDate ? year + "-" + month + "-" + dt : "";
    },
    /* go back to order detail screen */

    onClickGoBack () {
      const returnTo = this.$route.query.returnTo;
      const orderId =
        returnTo != null && String(returnTo) !== ""
          ? returnTo
          : this.$route.params.id;
      const { $router } = this;
      $router.push(`/admin/orders/${orderId}`);
    },
    /* init */
    updateImageFile (imageKey) {
      this.images.push(imageKey);
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/variables.scss";

.adminOrderContentTables .adminOrderContentTable {
  margin-left: 10%;
  margin-bottom: 5%;
  width: 80%;
  border: 1px solid $--border-color-lighter;
  border-collapse: collapse;
}
.adminOrderContentTables .adminOrderContentTable-th,
.adminOrderContentTables .adminOrderContentTable-td {
  text-align: left;
  padding: 10px 5px;
}
.adminOrderContentTables .adminOrderContentTable-td {
  width: 50%;
  padding-left: 1rem !important;
  font-size: 13px !important;
  border: 1px solid $--border-color-lighter;
  border-collapse: collapse;
}
.adminOrderContentTables .adminOrderContentTable-th {
  background: $background-gray-deep;
  font-size: 13px !important;
}
.AdminOrderDetailHeaderTopCenter {
  margin-top: 0.8rem;
  text-align: center;
}
.AdminOrderMessageHeaderTop button {
  margin: 0.5rem;
}
.adminOrderMessage {
  display: flex;
  height: 100%;
  width: 100%;
}
.orderMessageViewContainer {
  margin-top: 5px;
  width: 100%;
}
#messageContainer .column {
  width: 52%;
  height: 100%;
  float: left;
}
#messageContainer .column--right {
  width: 48%;
  float: right;
}
#messageContainer .Toolbar {
  align-items: center;
  padding: 10px;
}
#messageContainer .Toolbar-Left {
  flex: 1;
  justify-content: center;
  align-items: center;
}
#messageContainer .Toolbar-Center {
  flex: 1;
  justify-content: center;
  align-items: center;
  padding-right: 8rem;
}
#messageContainer .Toolbar-Right {
  margin-bottom: 3rem;
}
.AdminOrderMessageHeaderTop {
  font-weight: bold;
  margin-bottom: 3%;
}
.caretRightIcon {
  font-size: 30px;
  float: left;
  margin-right: 3.5%;
}
.backBtn {
  cursor: pointer;
  width: 50%;
  line-height: 1;
  margin-left: 0.8rem;
}
.bggray-colorwhite {
  display: inline-block;
  line-height: 1;
  color: white !important;
  cursor: not-allowed !important;
  background-image: none !important;
  background-color: $background-gray-deep !important;
  padding: 12px 20px !important;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid $blue-extra-deep !important;
  white-space: nowrap;
  -webkit-appearance: none;
  transition: 0.1s;
  font-weight: 500;
  font-size: 14px;
}
.bggray-colorblack {
  display: inline-block;
  line-height: 1;
  color: $text-lighter !important;
  background-image: none !important;
  background-color: $background-gray-deep !important;
  padding: 12px 20px !important;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid $blue-extra-deep !important;
  white-space: nowrap;
  -webkit-appearance: none;
  transition: 0.1s;
  font-weight: 500;
  font-size: 14px;

  &.not-allowed {
    cursor: not-allowed !important;
  }
}
.arrow-gray {
  color: $default-border-color-base !important;
}
.message-status {
  text-align: center;
  height: 40px;
  margin-top: 1rem;
}
.statusBold {
  font-weight: 600;
}
.AdminOrderMessageDialog .dialog-text {
  font-size: 17px;
  font-weight: bold;
}
.AdminOrderMessageDialog .assignerDialog .el-dialog--center .el-dialog__body {
  text-align: center;
  padding-bottom: 2rem;
  padding-top: 3rem;
  margin-top: 1rem;
}
.AdminOrderMessageDialog .assignerDialog .dialog-text {
  font-size: 19.5px;
  font-weight: bold;
}
.AdminOrderMessageDialog .el-button {
  border: none;
}
.AdminOrderMessageDialog .el-dialog__close {
  display: none;
}
.AdminOrderMessageDialog .btn-blue-text {
  color: $blue-extra-deep;
}
.AdminOrderMessageDialog .dialog-text {
  font-size: 17px;
  font-weight: bold;
}
.AdminOrderMessageDialog .el-dialog--center .el-dialog__body {
  text-align: center;
  padding-bottom: 4rem;
  padding-top: 4.5rem;
  margin-top: 1rem;
  height: 15%;
}
.AdminOrderMessageDialog .el-button {
  border: none;
}
.AdminOrderMessageDialog .el-dialog__close {
  display: none;
}
.AdminOrderMessageDialog .blue-text-btn {
  color: $blue-extra-deep;
}
.AdminOrderMessageDialog .dateInputDialog .date-input {
  width: 280px !important;
  margin: 0.5rem auto 0;
}
.AdminOrderMessageDialog .dateInputDialog .el-dialog__footer {
  margin-top: -1.5rem !important;
  margin-right: 0.3rem !important;
}
.AdminOrderMessageDialog .dialog-footer {
  margin-top: 1rem;
}
.AdminOrderMessageDialog .el-dialog__footer {
  padding: 10px 20px 20px;
  width: 100%;
  margin-top: 2rem;
}
.AdminOrderMessageDialog .el-dialog el-dialog--center {
  height: 60%;
}
@media (max-width: 1024px) {
  .AdminOrderMessageDialog .el-dialog {
    height: 40% !important;
  }
  .AdminOrderMessageDialog .el-dialog__footer {
    margin-top: 1rem !important;
  }
}
@media (max-width: 768px) {
  .AdminOrderMessageDialog .el-dialog {
    height: 30% !important;
    width: 45% !important;
  }
  .AdminOrderMessageDialog .el-dialog__footer {
    margin-top: 1rem !important;
  }
}
</style>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.statusButton {
  width: 220px;
}
</style>
